import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotLoggedInRoutingModule } from './not-logged-in-routing.module';
import { PublicSharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    NotLoggedInRoutingModule,
    PublicSharedModule
  ],
  declarations: []
})
export class NotLoggedInModule { }
